export const PREFIX = 'img-crop';

export const ZOOM_INITIAL = 1;
export const ZOOM_STEP = 0.1;

export const ROTATION_INITIAL = 0;
export const ROTATION_MIN = -180;
export const ROTATION_MAX = 180;
export const ROTATION_STEP = 1;

export const ASPECT_MIN = 0.5;
export const ASPECT_MAX = 2;
export const ASPECT_STEP = 0.01;
